import { renderCliente, bindCliente } from './cliente.js'

/** /entrar — alias de /cliente (login solo). */
export function renderLogin() {
  return renderCliente()
}

export function bindLogin(root, ctx) {
  bindCliente(root, ctx)
}
